<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout row wrap full-height justify-center>
        <v-flex>
            <v-form
                    ref="form"
                    lazy-validation
                    v-on:submit.prevent="onSubmit"
            >
                <v-card class="pa-1">
                    <v-card-title>
                        <h5 class="headline ml-2 mr-2">Upload A New Journal</h5>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex lg4 md4 sm5 xs12>
                                <div class="ml-2 mr-2">
                                    <v-select
                                            label="Select Media"
                                            v-model="selectedMediaId"
                                            item-text="name"
                                            item-value="id"
                                            :items="medias"
                                    ></v-select>
                                </div>
                            </v-flex>

                            <v-flex xs12>
                                <div class="ml-2 mr-2">
                                    <label class="text--secondary">Choose Type</label>
                                    <v-radio-group
                                            class="hide-top-margin"
                                            row
                                            v-model="selectedType"
                                    >
                                        <v-radio 
                                            v-for="type in types" 
                                            :key="type"
                                            :label="type" 
                                            :value="type"
                                            color="primary"
                                        ></v-radio>
                                    </v-radio-group>
                                </div>
                            </v-flex>

                            <v-flex lg4 md4 sm5 xs12>
                                <div class="ml-2 mr-2">
                                    <v-menu
                                            v-model="dateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            max-width="290px"
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="computedDateFormatted"
                                                    label="Publish Date"
                                                    readonly
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                color="primary"
                                                v-model="selectedPublishDate" no-title
                                                @input="dateMenu = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </div>
                            </v-flex>

                            <v-flex xs12>
                                <upload-btn
                                        id="images-upload-btn"
                                        title="Upload Images"
                                        multiple
                                        class="hide-padding"
                                        accept="image/*"
                                        color="primary"
                                        outline
                                        hover
                                        :fileChangedCallback="onFilesUploaded"
                                >
                                    <template slot="icon-left">
                                        &nbsp;
                                        <v-icon left color="black">cloud_upload</v-icon>
                                    </template>
                                </upload-btn>
                            </v-flex>

                            <v-flex lg2 md3 sm4 v-if="uploadedFiles.length" align-self-center>
                                <div class="ml-1 mr-1">
                                    <v-checkbox v-model="front" label="Front cover page"></v-checkbox>
                                </div>
                            </v-flex>

                            <v-flex lg2 md3 sm4 v-if="uploadedFiles.length" align-self-center>
                                <div class="ml-1 mr-1">
                                    <v-checkbox v-model="back" label="Back cover page"></v-checkbox>
                                </div>
                            </v-flex>

                            <v-flex xs12>
                                <div class="ml-1 mr-1">
                                    <images-grid
                                            :items="uploadedFiles"
                                            :front="front"
                                            :back="back"
                                            @remove="onRemoved"
                                            @sort="onSorted"
                                            @item-click="onItemClicked"
                                    ></images-grid>
                                </div>
                            </v-flex>

                            <v-flex xs12>
                                <v-btn class="error" @click="resetForm">Reset</v-btn>
                                <v-btn id="btnSubmit" class="primary" type="submit">Submit</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-flex>
        <v-dialog v-model="imgPopup">
            <div>
                <v-img :src="imgPopupUrl"></v-img>
            </div>
        </v-dialog>

        <v-dialog
                v-model="loading"
                hide-overlay
                persistent
                width="300"
        >
            <v-card
                    color="primary"
                    dark
            >
                <v-card-text>
                    Uploading...
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="uploadComplete"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">Info</v-card-title>
                <v-card-text>
                    Upload Complete!
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            flat="flat"
                            @click="uploadComplete = false"
                    >Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="errorDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">Error</v-card-title>
                <v-card-text>All fields are required!</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            flat
                            @click="errorDialog = false"
                    >Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import UploadButton from 'vuetify-upload-button'
    import md5 from 'js-md5'
    import ImagesGrid from "../components/ImagesGrid"
    import {convertToFormData, getPageIndex} from "../services/page.services"
    import { mapState, mapActions } from "vuex";
    import {ImageServices} from "../services/image.services";
    import { chunk } from "../utils/array.utils";
    import current_user from "../mixins/current_user";

    export default {
        components: {
            'upload-btn': UploadButton,
            'images-grid': ImagesGrid
        },

        mixins: [current_user],

        data() {
            return {
                types: [],
                dateMenu: false,
                selectedMediaId: 0,
                selectedType: 'Daily',
                selectedPublishDate: new Date().toISOString().substr(0, 10),
                uploadedFiles: [],
                front: true,
                back: true,
                imgPopup: false,
                popupImages: '',
                sorted: [],
                loading: false,
                uploadComplete: false,
                errorDialog: false,
                imgPopupUrl: ''
            }
        },

        created() {
            this.types = ['Daily', 'Weekly', 'Monthly']
        },

        methods: {
            ...mapActions('journals', [
                'createJournal',
                'uploadPages'
            ]),

            onSubmit() {
                if (this.validateForm()) {
                    this.loading = true;

                    const journal = {
                        media: {
                            id: this.selectedMediaId
                        },
                        type: this.selectedType,
                        publishDate: Date.parse(this.selectedPublishDate)
                    };

                    this.createJournal(journal)
                        .then(({ data }) => {
                            const pagesMapping = {};

                            this.sorted.forEach((cs, index) => {
                                pagesMapping[cs] = getPageIndex(
                                    index, this.sorted, this.front, this.back);
                            });

                            this.$ua.trackEvent('JournalUpload', 'click', 
                                `${this.currentUser.username || 'User'} uploaded ${data.id} with ${this.uploadedFiles.length} pages`);

                            const uploads = [];
                            chunk(this.uploadedFiles, 10)
                            .forEach(pages => {
                                const files = pages.map(p => p.file);
                                const formData = convertToFormData(files, pagesMapping, data.id);
                                uploads.push(this.uploadPages(formData));
                            });
                            return Promise.all(uploads);
                        })
                        .then(() => {
                            this.resetForm();
                            this.uploadComplete = true;
                        })
                        .finally(() => ( this.loading = false ));
                } else {
                    this.errorDialog = true
                }
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },
            onFilesUploaded(files) {
                let tempAry = [] // to hold files for sorting
                this.loading = true

                Array.from(files)
                    .sort((file1, file2) => file1.name.localeCompare(file2.name))
                    .forEach((file, index) => {
                        const reader = new FileReader()
                        reader.onload = e => {
                            const checksum = md5(e.target.result)

                            if (this.isFileExist(checksum)) return

                            let blob = new Blob([e.target.result])
                            window.URL = window.URL || window.webkitURL
                            let blobURL = window.URL.createObjectURL(blob)

                            let image = new Image()
                            image.src = blobURL
                            image.onload = () => {
                                let resized = ImageServices.resizeMe(image)
                                tempAry.push({
                                    index: index,
                                    checksum: checksum,
                                    url: resized,
                                    originalUrl: blobURL,
                                    file: file
                                })

                                if (tempAry.length === files.length) {
                                    tempAry
                                        .sort((file1, file2) => file1.index - file2.index)
                                        .forEach(file => this.uploadedFiles.push(file))
                                    this.loading = false
                                }
                            }
                        }
                        reader.readAsArrayBuffer(file)
                    })
            },
            isFileExist(checksum) {
                return this.uploadedFiles.find(file => file.checksum === checksum)
            },
            onRemoved(checksum) {
                const index = this.uploadedFiles.findIndex(file => file.checksum === checksum)
                if (index !== -1) this.uploadedFiles.splice(index, 1)
            },
            onSorted(images) {
                this.sorted = images
            },
            onItemClicked(checksum) {
                const file = this.uploadedFiles.find(file => file.checksum === checksum)
                if (file) {
                    this.imgPopup = true
                    this.imgPopupUrl = file.originalUrl
                }
            },
            validateForm() {
                if (this.selectedMediaId === 0) {
                    return false;
                }

                if (this.selectedType === '') {
                    return false;
                }

                if (this.selectedPublishDate === '') {
                    return false;
                }

                if (this.uploadedFiles.length === 0) {
                    return false;
                }

                return true;
            },
            resetForm() {
                this.selectedMediaId = 0
                this.selectedType = 'Daily'
                this.selectedPublishDate = new Date().toISOString().substr(0, 10)
                this.uploadedFiles = []
                this.computedDateFormatted = new Date().toISOString().substr(0, 10)
            }
        },

        computed: {
            computedDateFormatted: {
                get: function () {
                    return this.formatDate(this.selectedPublishDate)
                },
                set: function (value) {
                    this.selectedPublishDate = value
                }
            },

            ...mapState('medias', [
                'medias'
            ])
        }
    }
</script>

<style scoped>
    .hide-padding {
        padding: 0 !important;
    }

    .hide-top-margin {
        margin-top: 0;
    }
</style>
